import { DateInputValues } from "../types";

export const areInputValuesFilled = (inputValues: DateInputValues) => {
  const { dayInput, monthInput, yearInput } = inputValues;

  return dayInput !== "" && monthInput !== "" && yearInput !== "";
};
